"use client";

import { useHeaderTheme } from "../../../HeaderTheme";
import React, { useEffect } from "react";

import type { HeroBlockDoc as HeroBlock } from "../../../types/blocks";

import { Media } from "../../../Media/Media";
import RichText from "../../../RichText";
import { CMSLink } from "../../components/CMSLink";

export const HighImpactHero: React.FC<HeroBlock> = ({
  links,
  media,
  richText,
  title,
  subtitle,
}) => {
  const { setHeaderTheme } = useHeaderTheme();

  useEffect(() => {
    setHeaderTheme("dark");
  });

  return (
    <div
      className="relative -mt-[10.4rem] flex items-center justify-center text-white"
      data-theme="dark"
    >
      <div className="container mb-8 z-10 relative flex items-center justify-center">
        <div className="max-w-[36.5rem] md:text-center">
          {title && <h1 className="text-5xl">{title}</h1>}
          {subtitle && <h2 className="text-2xl">{subtitle}</h2>}
          {richText && (
            <RichText className="mb-6" data={richText} enableGutter={false} />
          )}
          {Array.isArray(links) && links.length > 0 && (
            <ul className="flex md:justify-center gap-4">
              {links.map(({ link }, i) => {
                return (
                  <li key={i}>
                    <CMSLink {...link} />
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
      <div className="min-h-[80vh] select-none">
        {media && typeof media === "object" && (
          <Media
            fill
            imgClassName="-z-10 object-cover"
            priority
            resource={media}
          />
        )}
      </div>
    </div>
  );
};
